const WorldIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M21.54 15H17C16.4696 15 15.9609 15.2107 15.5858 15.5858C15.2107 15.9609 15 16.4696 15 17V21.54"
        stroke="#00CF83"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 3.34009V5.00009C7 5.79574 7.31607 6.5588 7.87868 7.12141C8.44129 7.68402 9.20435 8.00009 10 8.00009C10.5304 8.00009 11.0391 8.2108 11.4142 8.58587C11.7893 8.96095 12 9.46965 12 10.0001C12 11.1001 12.9 12.0001 14 12.0001C14.5304 12.0001 15.0391 11.7894 15.4142 11.4143C15.7893 11.0392 16 10.5305 16 10.0001C16 8.90009 16.9 8.00009 18 8.00009H21.17"
        stroke="#00CF83"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9998 21.95V18C10.9998 17.4696 10.7891 16.9609 10.414 16.5858C10.0389 16.2107 9.53024 16 8.9998 16C8.46937 16 7.96066 15.7893 7.58559 15.4142C7.21052 15.0391 6.9998 14.5304 6.9998 14V13C6.9998 12.4696 6.78909 11.9609 6.41402 11.5858C6.03895 11.2107 5.53024 11 4.9998 11H2.0498"
        stroke="#00CF83"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="#00CF83"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default WorldIcon
